import React, { useRef, useEffect } from "react";
import DOMPurify from "dompurify";

const LargestAiSection = ({ data }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.muted = true; // Autoplay ke liye mute required hota hai
      videoRef.current.play().catch((error) => {
        console.error("Video autoplay error:", error);
      });
    }
  }, []);

  const userAgent = navigator.userAgent;
  return (
    <div className="about_section_wrapper about_largest_ai_sec">
      <div className="about_section_row">
        <div className="about_img_wrapper">
          <div
            className="image_container about_container_img"
            style={{ position: "relative" }}
          >
            {!(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) ? (
              <video
                ref={videoRef}
                muted
                autoPlay
                loop
                playsInline
                style={{ width: "100%", display: "block" }}
              >
                <source
                  src="https://47.activ8.digital/wp-content/uploads/2026/04/SKY-47-Time-lapse-20-Sec.-1920X1080.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            ) : (
              <img
                src="https://47.activ8.digital/wp-content/uploads/2026/04/A-SKY-47-Time-lapse-03-Sec.-640x360-.gif"
                alt="largest-ai-section-image"
                className="largest-ai-section-mob-image"
              />
            )}
          </div>
        </div>

        <div className="about_content_wrapper largest_ai_col">
          {/* ---- same as before ---- */}
          <div className="overlap-group-wrapper">
            <div className="overlap-group">
              <div className="group-wrapper">
                <div className="group">
                  <div className="ellipse"></div>
                  <div className="div"></div>
                  <div className="ellipse-2"></div>
                </div>
              </div>
            </div>
          </div>

          <div className="content_section p-4">
            <p className="behind_text">Behind the Build</p>

            <h2
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(data?.main_heading || ""),
              }}
              className="main_heading"
            ></h2>

            <h3 className="sub_heading">{data?.sub_heading}</h3>

            <p
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(data?.paragraph || ""),
              }}
              className="about_description"
            ></p>

            <a className="white_btn" href={data?.button_url}>
              {data?.button_text}
              {/* SVG Icon */}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LargestAiSection;
